<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h2>VIEW - FARM MANAGEMENT</h2>
       <p>Farm details</p>
       <!--<a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
        Back
       </a>-->
       </div>
      </div>
       <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12">
       <div class="grid_view">
       <h3>&nbsp;</h3>
       <div class="card mt-0">
       <div class="card-body">
       <div class="row">
       <div class="col-lg-4 col-sm-4 col-12">
       <p><span class="blue">Farm Name:&nbsp;</span><span id="FarmName"></span></p>
       <p><span class="blue">Contact Email:&nbsp;</span><span id="ContactEmail"></span></p>
       </div>
       <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Farm ID:&nbsp;</span><span id="FarmID"></span></p>
        <p><span class="blue">Contact Number:&nbsp;</span><span id="ContactNumber"></span></p>
        </div>
       <div class="col-lg-4 col-sm-4 col-12">
       <p><span class="blue">Contact Person:&nbsp;</span><span id="ContactPerson"></span></p>
       <p><span class="blue">Address:&nbsp;</span> <span id="Address"></span></p>
       </div>
       </div>
       </div>
       </div>
       </div>
       </div>
       <div class="col-lg-12 col-md-12 col-sm-12 text-center">
       <button type="submit" (click)='farmsmanagement()' class="btn btn-fill btn-primary mb-3">
        Back <div class="ripple-container"></div>
       </button>
       </div>
       </div>
     </div>
   </div>
 </div>